import React from 'react';
import PropTypes from 'prop-types';

const FixedContainer = props => {
  const { padding, classed, children } = props;
  return (
    <div className={`fixed-container ${classed} ${padding ? 'fixed-container--padding' : ''}`}>
      {children}
    </div>
  );
};

FixedContainer.propTypes = {
  padding: PropTypes.bool,
  classed: PropTypes.string,
};

export default FixedContainer;
